import React, { useState } from 'react';


import {
    Alert,
    Card,
    Input,
    Button,
    Typography,
    IconButton,
    Textarea,

} from "@material-tailwind/react";



import { } from "@heroicons/react/24/outline";

import { XMarkIcon } from '@heroicons/react/24/outline';
import { showAlert } from './Alert.jsx';
import { sendEmail } from './SendEmail.jsx';




export default function AnalizyCard(props) {


    const [session, setSession] = useState(localStorage.getItem("session") || null);

    const [sysname, setSysname] = useState(props.sysname);
    const [shortname, setShortname] = useState(props.shortname);
    const [description, setDescription] = useState(props.description);
    const [sendDisabled, setSendDisabled] = useState(false);



    function cancelClose() {
        props.close();
    }


    function messageUpdate(e) {
        setMessage(e);
    }



    function handleDataResponse(data) {
        setSendDisabled(false); //tymczasowo odblokuj przycisk wyślij
        if (data.status === "ok") {
            showAlert("green", data.message, 4000);
            props.close();
        }
        if (data.status !== "ok") {
            showAlert("red", data.message, 4000);
        }
    }



    function handleSubmit(e) {
        e.preventDefault();
        setSendDisabled(true); //tymczasowo zablokuj przycisk wyślij
        var bodydata = JSON.stringify({ action: 'create', session: session, sysname:sysname.trim() , shortname: shortname.trim(), description: description.trim()}); //create or update if exists
        console.log(bodydata);
        fetch('https://online.mysoil.pl/cgi-bin/analizy.py', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: bodydata,
            mode: 'cors'

        })
            .then(res => res.json())
            .then(data => { console.log("data"); console.log(data); handleDataResponse(data); })
    }




    return (
        <div className='absolute w-full h-full top-0 items-center justify-cener m-auto z-[30] flex place-content-center bg-black/50 '>

            <Card color="white" className="w-full max-w-[20rem] mx-auto rounded-lg max-h-[94vh] overflow-y-auto" shadow={false}>

                <div className="flex items-center justify-between gap-4 w-auto bg-gradient-to-br from-teal-500/75 to-cyan-500/75 pt-2 pb-2 rounded-t-lg">
                    <Typography color="white" variant="h6" className="mt-2 pl-12 font-normal mx-auto">
                        Parametr analizy laboratoryjnej
                    </Typography>
                    <IconButton variant='text' className='right-2' color="white" data-refresh={false} onClick={cancelClose}>
                        <XMarkIcon className='w-6 h-6' />
                    </IconButton>

                </div>
                <form className="mt-6 mb-2 mx-auto w-full max-w-[20rem]  items-center justify-center px-6" onSubmit={handleSubmit}>
                    <div className="mb-6 flex flex-col gap-4 w-auto items-center justify-center ">


                        <Input size="md" label="Symbol badania (unikalny)" className="shadow-md w-auto" value={sysname} onChange={e=> setSysname(e.target.value)}  />

                        <Input size="md" label="Krótka nazwa" className="shadow-md" value={shortname} onChange={e=> setShortname(e.target.value)} />

                        <Input size="md" label="Opis" className="shadow-md" value={description} onChange={e=> setDescription(e.target.value)} />

                        <Button className="flex items-center max-w-[10rem] my-0 justify-center bg-gradient-to-br from-teal-500 to-cyan-500 mx-auto" disabled={sendDisabled} data-refresh={true} fullWidth type="submit">
                            Zapisz
                        </Button>
                    </div>

                </form>
            </Card>

        </div>
    );
}

